import { render, staticRenderFns } from "./o-button-back.vue?vue&type=template&id=723399ad"
import script from "./o-button-back.js?vue&type=script&lang=js&external"
export * from "./o-button-back.js?vue&type=script&lang=js&external"
import style0 from "./o-button-back.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports